﻿import { Output } from "@models/configurators/outputs/output";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IOutput, ITextOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { Kbo, KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutput(CToken.TextOutput, eOutputType.text)
export class TextOutput extends FileOutput implements ITextOutput {

    public textContent: string = "";

    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
        this.type = eOutputType.text;
    }
}
